import React, { useEffect, useState } from "react";
import { Form, Button, Col, Row, FormControl } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import * as Constants from "../../../constants/Constants";
import ShippingTitleName from "./TabHeader/ShippingTitleName";
import { ToolTip } from "../../Common/Tooltip/ToolTip";
import { TooltipIcon } from "../../../assets/js/image";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import ErrorContainer from "../../Common/Errors/ErrorContainer";
import "./LocationDetails.css";
import Cookies from "js-cookie";
import {
  httpGetConfigValues,
  httpGetShippingLocationDetails,
  httpPostUpdateShippingLocation,
} from "../../../service/httpClient";
import OnSubmitErrorMessage from "../../Common/Errors/OnSubmitErrorMessage";
import { formatPhone } from "../../Dashboard/Views/AddNewVendor/formFields";

import {
  SimilarAddresses,
  defaultAutoCompleteFieldChange,
  defaultOnSelectAddress,
  handleValidate,
  consturctAddressState,
} from "../../../components/VendorOnboarding/Views/Address/helpers";

import { shippingLocationAddressFields } from "../../../components/ShippingLocation/Views/Address/ShippingFormFields";

const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
const emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const nameRegex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]?|[A-Za-z`~!@#$%^&*()=+\{\}\[\]\\|;:'",<.>//?_-\s])*$/;

const schema = yup.object().shape({
  locationName: yup.string().required("Please fill out Location Name."),
  contacts: yup
    .array()
    .of(
      yup.object().shape({
        firstName: yup
          .string()
          .min(2, "Need at least 2 characters.")
          .matches(
            nameRegex,
            "The first name may only contain letters, space, and special characters."
          )
          .notRequired(),
        lastName: yup
          .string()
          .min(2, "Need at least 2 characters.")
          .matches(
            nameRegex,
            "The last name may only contain letters, space, and special characters."
          )
          .notRequired(),
        phoneNumber: yup
          .string()
          .min(10, "Phone number should be 10 characters long")
          .matches(phoneRegExp, "Phone number is not valid.")
          .notRequired(),
        email: yup
          .string()
          .email("Email is not valid.")
          .min(5, "Must be more than 5 characters")
          .matches(emailValidation, "Email is not valid.")
          .notRequired(),
      })
    )
    .required("Contact details are required."),
});

const LocationDetails = (props) => {
  const updatedLocation = props?.history?.location?.state;
  const history = useHistory();
  const [shippingLocs, setShippingLocs] = useState({
    locationName: "",
    status: "Active",
    shippingAddress: {
      streetAddress: "",
      suiteUnitFloor: "",
      cityShipping: "",
      state: "",
      zipCode: "",
      country: "",
    },
    contacts: [
      {
        contactID: 0,
        id: 0,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        primary: false,
      },
    ],
    timezone: "EST",
    openHours: "No",
    dateArray: [
      {
        sunday: false,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: false,
      },
    ],
    disableAllDays: false,
    uniqueContactError: false,
  });

  const [primaryExist, setPrimaryExist] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [locationSuccessMsg, setLocationSuccessMsg] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);
  const [locationErrorMsg, setLocationErrorMsg] = useState(false);
  const [isDataChange, setIsDataChange] = useState(false);
  const [savePressed, setSavePressed] = useState(false);
  const [isUpdateFrm, setIsUpdateFrm] = useState(false);

  const setPrimary = () => {
    let isPrimFlag = false;
    shippingLocs.contacts.map((val, i) => {
      if (val.primary) {
        isPrimFlag = true;
        return isPrimFlag;
      }
    });
    return isPrimFlag;
  };
  const resetErrorMessages = () => {
    setLocationErrorMsg("");
    setErrorStatus(false);
    setUpdateStatus(false);
    setLocationErrorMsg("");
    setIsDataChange(true);
    setSavePressed(false);
  };

  const validFlag =
    shippingLocs?.locationName !== "" &&
    shippingLocs?.shippingAddress?.streetAddress !== "" &&
    primaryExist === true;

  const [coordinateDetails, setCooordiinateDetails] = useState({
    latitude: "",
    longitude: "",
    tmstamp: "",
    exactLatitude: "",
    exactLongitude: "",
  });

  const setCoordinates = (lat, lng, tms) => {
    setCooordiinateDetails({
      latitude: lat.toFixed(4),
      longitude: lng.toFixed(4),
      tmstamp: tms,
      exactLatitude: lat,
      exactLongitude: lng,
    });
  };

  const isPopulatedContactsData = () => {
    let isSelectContactDetails = false;
    if (Object.keys(errors).length !== 0) {
      return true;
    }
    let tempContactArray = shippingLocs.contacts;
    for (let i = 0; i < tempContactArray.length; i++) {
      if (
        tempContactArray[i].firstName === "" ||
        tempContactArray[i].firstName.length < 2 ||
        tempContactArray[i].lastName === "" ||
        tempContactArray[i].lastName.length < 2 ||
        tempContactArray[i].phoneNumber === "" ||
        tempContactArray[i].email === "" ||
        tempContactArray[i].email.length < 5
      ) {
        isSelectContactDetails = true;
        break;
      }
    }
    const tempDateArray = shippingLocs?.dateArray;
    const isUnCheckAllDays =
      tempDateArray?.length > 0 && isUnCheckDays(tempDateArray[0]);
    return isSelectContactDetails || isUnCheckAllDays;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = (data, e) => {
    e.preventDefault();
    reset();
  };

  const handleDateFlip = (e) => {
    resetErrorMessages();
    const { name } = e.target;
    const tempDateArray = shippingLocs.dateArray;
    tempDateArray.map((val) => {
      if (typeof val[name] !== "undefined") {
        val[name] = !val[name];
      }
    });

    var toggleOpenHrs = checkDays(tempDateArray[0]);
    setShippingLocs({
      ...shippingLocs,
      openHours: toggleOpenHrs ? "Yes" : "No",
      disableAllDays: toggleOpenHrs ? true : false,
      dateArray: tempDateArray,
    });
    resetErrorMessages();
  };

  const checkDays = (days) => {
    return (
      days.sunday === true &&
      days.monday === true &&
      days.tuesday === true &&
      days.wednesday === true &&
      days.thursday === true &&
      days.friday === true &&
      days.saturday === true
    );
  };
  const isUnCheckDays = (days) => {
    return (
      days.sunday === false &&
      days.monday === false &&
      days.tuesday === false &&
      days.wednesday === false &&
      days.thursday === false &&
      days.friday === false &&
      days.saturday === false
    );
  };

  const handleSave = () => {
    if (validFlag) {
      uniqueContact();
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "openHours") {
      handleDaysOnChangeOpenHours(e.target.value);
    } else {
      setShippingLocs({
        ...shippingLocs,
        [e.target.name]: e.target.value,
      });
    }
    resetErrorMessages();
  };

  const handleDaysOnChangeOpenHours = (openHours) => {
    let excludeDaysArr = [];
    let disableAllDays = false;
    if (openHours.toLowerCase() === "yes") {
      disableAllDays = true;
    } else {
      excludeDaysArr = ["saturday", "sunday"];
    }
    let dateArr = shippingLocs?.dateArray;
    for (const index in dateArr) {
      for (const dayVal in dateArr[index]) {
        if (excludeDaysArr.length > 0 && excludeDaysArr.includes(dayVal)) {
          dateArr[index][dayVal] = false;
        } else {
          dateArr[index][dayVal] = true;
        }
      }
    }
    setShippingLocs({
      ...shippingLocs,
      openHours: openHours,
      dateArray: dateArr,
      disableAllDays: disableAllDays,
    });
  };

  const handlePrimaryChange = (e, index) => {
    const { id, value, name } = e.target;
    let tempContactArray = shippingLocs.contacts;
    let contactPresent =
      shippingLocs.contacts[index].firstName !== "" &&
      shippingLocs.contacts[index].lastName !== "" &&
      shippingLocs.contacts[index].phoneNumber !== "" &&
      shippingLocs.contacts[index].email !== "" &&
      shippingLocs.contacts[index].email.length > 5;
    tempContactArray.map((val, i) => {
      if (name.indexOf("primary") > -1 && index === i && contactPresent) {
        val.primary = true;
      } else if (index === i && !contactPresent) {
        val.primary = false;
      } else {
        val.primary = false;
      }
    });
    resetErrorMessages();
    setShippingLocs({
      ...shippingLocs,
      contacts: tempContactArray,
    });
    let pFlag = setPrimary();
    setPrimaryExist(pFlag);
  };
  const prepareDaysString = () => {
    const dtArr = shippingLocs.dateArray;
    let dateStr = "";
    if (dtArr && dtArr.length && dtArr[0]) {
      const days = dtArr[0];

      days.sunday ? (dateStr += "1") : (dateStr += "0");
      days.monday ? (dateStr += "1") : (dateStr += "0");
      days.tuesday ? (dateStr += "1") : (dateStr += "0");
      days.wednesday ? (dateStr += "1") : (dateStr += "0");
      days.thursday ? (dateStr += "1") : (dateStr += "0");
      days.friday ? (dateStr += "1") : (dateStr += "0");
      days.saturday ? (dateStr += "1") : (dateStr += "0");
    }
    return dateStr;
  };

  const handleContactChange = (e, index) => {
    resetErrorMessages();
    const { id, value, name } = e.target;
    let tempContactArray = shippingLocs.contacts;
    tempContactArray.map((val, i) => {
      if (index === i) {
        if (id.indexOf("firstName") > -1) {
          val.firstName = value;
        } else if (id.indexOf("lastName") > -1) {
          val.lastName = value;
        } else if (id.indexOf("phoneNumber") > -1) {
          val.phoneNumber = formatPhone(value);
        } else if (id.indexOf("email") > -1) {
          val.email = value;
        }
        if (shippingLocs.contacts[i].primary) {
          handlePrimaryChange(e, i);
        }
      }
    });
    setShippingLocs({
      ...shippingLocs,
      contacts: tempContactArray,
    });
  };

  const uniqueContact = () => {
    setShippingLocs({
      ...shippingLocs,
      uniqueContactError: false,
    });
    shippingLocs.contacts.map((item) => {
      if (item.primary) {
        item.category = "PRIMARY";
      } else {
        item.category = "SECONDARY";
      }
      item.createdBy =
        shippingLocs.createdBy || Cookies.get("email").toLowerCase();
      item.updatedBy =
        shippingLocs.createdBy || Cookies.get("email").toLowerCase();
      item.vendorShipLocationId = shippingLocs.id;
      return item;
    });
    const dates = prepareDaysString();
    const payload = {};
    payload.dayOfWeek = dates;
    const {
      id,
      locationName,
      openHours,
      status,
      contacts,
      createdBy,
    } = shippingLocs;
    const { vendorProfileId = "" } = updatedLocation || {};
    const { longitude, latitude } = coordinateDetails;
    const { shippingAddress } = formValues;
    const {
      cityShipping,
      state,
      zipCode,
      country,
      suiteUnitFloor,
      streetAddress,
    } = shippingAddress;
    payload.id = id;
    payload.vendorProfileId = vendorProfileId || props.vendorProfileId;
    payload.locationId = latitude + longitude;
    payload.latitude = coordinateDetails.exactLatitude;
    payload.longitude = coordinateDetails.exactLongitude;
    payload.locationName = locationName;
    payload.streetName = streetAddress;
    payload.suiteNumber = suiteUnitFloor;
    payload.city = cityShipping;
    payload.state = state;
    payload.zipCode = zipCode;
    payload.country = country;
    payload.isAllDayOperation = openHours?.toUpperCase();
    payload.locationStatus = status?.toUpperCase();
    payload.timeZone = coordinateDetails.tmstamp;
    payload.shippingContact = contacts;
    payload.updatedBy = createdBy || Cookies.get("email").toLowerCase();
    payload.createdBy = createdBy || Cookies.get("email").toLowerCase();
    let isDublicateFlag = false;

    let locationLength = shippingLocs.contacts.length;
    let tempContactArray = { ...shippingLocs.contacts };
    for (var i = 0; i < locationLength; i++) {
      for (var j = locationLength - 1; j > i; j--) {
        if (
          tempContactArray[i].firstName.toLowerCase().trim() ===
            tempContactArray[j].firstName.toLowerCase().trim() &&
          tempContactArray[i].lastName.toLowerCase().trim() ===
            tempContactArray[j].lastName.toLowerCase().trim()
        ) {
          setShippingLocs({
            ...shippingLocs,
            uniqueContactError: true,
          });
          isDublicateFlag = true;
        }
      }
    }
    if (!isDublicateFlag) {
      httpPostUpdateShippingLocation(payload)
        .then((response) => {
          if (!updatedLocation) {
            onSaveSuccessUpdateLocationState(response?.data);
          }
          updateSuccessMessage();
          setErrorStatus(false);
          setSavePressed(true);
        })
        .catch((err) => {
          setLocationErrorMsg(err?.response?.data?.message || err.message);
          setUpdateStatus(false);
          setErrorStatus(true);
        });
    }
  };

  const onSaveSuccessUpdateLocationState = (record) => {
    const {
      id,
      createdBy,
      updatedBy,
      locationId,
      timeZone,
      latitude,
      longitude,
    } = record;
    let tempContactArray = record.shippingContact;
    const contacts = tempContactArray.map((item) => {
      if (item.category.toUpperCase() === "PRIMARY") {
        item.primary = true;
      } else {
        item.primary = false;
      }
      return item;
    });
    setShippingLocs({
      ...shippingLocs,
      id: id,
      createdBy: createdBy,
      updatedBy: updatedBy,
      contacts: contacts,
      uniqueContactError: false,
    });
    setCooordiinateDetails({
      latitude: `${locationId.split("-")[0]}`,
      longitude: `-${locationId.split("-")[1]}`,
      tmstamp: timeZone,
      exactLatitude: latitude,
      exactLongitude: longitude,
    });
    setIsUpdateFrm(true);
  };

  const updateSuccessMessage = () => {
    setUpdateStatus(true);
    setLocationSuccessMsg(Constants.VENDOR_CONTACT_SUCCESS_MESSAGE);
  };

  const handleAddClick = () => {
    const tempContactArray = shippingLocs.contacts;
    tempContactArray.push({
      contactID: shippingLocs.contacts.length,
      id: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      primary: false,
      category: null,
      createdBy: Cookies.get("email"),
      updatedBy: Cookies.get("email"),
    });
    setShippingLocs({
      ...shippingLocs,
      contacts: tempContactArray,
    });
  };

  const handleRemoveRow = (index) => {
    const tempContactArray = shippingLocs.contacts;
    if (tempContactArray.length !== 0) {
      tempContactArray.splice(index, 1);
      tempContactArray.map((val, i) => {
        val.contactID = i;
      });
      setShippingLocs({
        ...shippingLocs,
        contacts: tempContactArray,
      });
      setSavePressed(false);
      setPrimaryExist(setPrimary());
      setIsDataChange(true);
      reset();
    }
  };

  const store = useSelector(({ service }) => service.vendorProfile);
  const initialState = {
    ...consturctAddressState({}),
    billingCheckbox: false,
    requestErrorMessage: "",
    errors: {},
    validForm: false,
    valuesChanged: false,
    otherAddress: store?.otherAddress || [],
    formDisabled: false,
    disableSubmit: false,
  };
  const [formValues, setFormValues] = useState({
    ...initialState,
    prev: initialState,
  });
  useEffect(() => {
    const { shippingAddress } = formValues;
    const {
      streetAddress,
      cityShipping,
      state,
      zipCode,
      country,
    } = shippingAddress;
    setShippingLocs({
      ...shippingLocs,
      shippingAddress: { streetAddress, cityShipping, state, zipCode, country },
    });
  }, [formValues.shippingAddress]);

  useEffect(() => {
    if (updatedLocation) {
      let record = {};
      httpGetShippingLocationDetails(updatedLocation.vendorProfileId).then(
        (response) => {
          const { data = [], status } = response || {};
          if (data?.length > 0 && status === 200) {
            const selectedLocation = data.filter(
              (item) => item.locationId === updatedLocation.locationId
            );
            record = selectedLocation[0];
            const {
              streetName,
              city,
              state,
              zipCode,
              country,
              suiteNumber,
              locationId,
              locationName,
              locationStatus,
              dayOfWeek,
              isAllDayOperation,
              id,
              timeZone,
              createdBy,
              updatedBy,
              firstName,
              latitude,
              longitude,
            } = record;
            let tempContactArray = record.shippingContact;
            const dtArr = [
              {
                sunday: dayOfWeek[0] == "1" ? true : false,
                monday: dayOfWeek[1] == "1" ? true : false,
                tuesday: dayOfWeek[2] == "1" ? true : false,
                wednesday: dayOfWeek[3] == "1" ? true : false,
                thursday: dayOfWeek[4] == "1" ? true : false,
                friday: dayOfWeek[5] == "1" ? true : false,
                saturday: dayOfWeek[6] == "1" ? true : false,
              },
            ];
            tempContactArray.map((val) => {
              if (val["firstName"]) {
                val.firstName = val.firstName;
              }
              if (val["lastName"]) {
                val.lastName = val.lastName;
              }
              if (val["email"]) {
                val.email = val.email;
              }
              if (val["phoneNumber"]) {
                val.phoneNumber = val.phoneNumber;
              }
              if (val["category"]) {
                val.category = val.category;
                val.primary =
                  val.category?.toLowerCase() == "primary" ? true : false;
              }
            });
            const contacts = tempContactArray.map((item) => item);
            setCooordiinateDetails({
              latitude: `${locationId.split("-")[0]}`,
              longitude: `-${locationId.split("-")[1]}`,
              tmstamp: timeZone,
              exactLatitude: latitude,
              exactLongitude: longitude,
            });
            setShippingLocs({
              ...shippingLocs,
              locationName: locationName,
              status: locationStatus === "ACTIVE" ? "Active" : "Inactive",
              openHours: isAllDayOperation === "YES" ? "Yes" : "No",
              disableAllDays: isAllDayOperation === "YES" ? true : false,
              timezone: timeZone,
              dateArray: dtArr,
              id: id,
              createdBy: createdBy,
              updatedBy: updatedBy,
              shippingAddress: {
                streetName,
                cityShipping: city,
                state,
                zipCode,
                country,
                suiteNumber,
              },
              contacts: contacts,
            });
            setFormValues((prevState) => ({
              ...prevState,
              shippingAddress: {
                streetAddress: streetName,
                suiteUnitFloor: suiteNumber,

                cityShipping: city,
                state,
                zipCode,
                country,
              },
            }));
          }
        }
      );
      setPrimaryExist(true);
    }
  }, []);
  const handleCancelClick = (event) => {
    event.preventDefault();
    history.push({
      pathname: `/${Constants.BOARDING}/${Constants.SHIPPING}`,
      state: null,
    });
  };

  const [enableFeature, setEnableFeature] = useState();

  useEffect(() => {
    httpGetConfigValues().then((response) => {
      if (response?.data) {
        Object.values(response.data)
          .filter((res) => res.key.indexOf("shippingLocation") > -1)
          .map((val) => {
            let featureFlagEnabled = val.value;
            setEnableFeature(featureFlagEnabled);
          });
      }
    });
  }, []);
  const isFilledContacts = isPopulatedContactsData();
  const isLocationActive = () => shippingLocs.status === "Active";
  return (
    <div className="col-md-12">
      <Form name="newShippingLocations">
        <div className="shipping-location-title">
          <div>{`${
            updatedLocation || isUpdateFrm
              ? Constants.SHIPPING_EDIT
              : Constants.SHIPPING_ADD
          } ${Constants.SHIPPING_LOCATION_TITLE}`}</div>
          <TooltipIcon style="shipping-location-title-icon"></TooltipIcon>
        </div>
        <div>
          <hr></hr>
          <div
            style={{
              marginTop: "20px",
              marginLeft: "-20px",
              marginBottom: "-20px",
            }}
          >
            <div>
              <ErrorContainer
                updateStatus={updateStatus}
                successMsg={locationSuccessMsg}
                errorMsg={locationErrorMsg}
                errorStatus={errorStatus}
                errorStyle="errorMessage"
                successStyle="successMessage"
              />
            </div>
          </div>
        </div>

        <>
          {enableFeature === Constants.ENABLED_FLAG ? (
            <>
              <Form.Row>
                <ShippingTitleName
                  title={Constants.SHIPPING_LOCATION_INFORMATION}
                />
              </Form.Row>

              <Form.Row className="col-md-12 mt-2">
                <Form.Group as={Col} md={3}>
                  <ToolTip
                    toolTipId="toolTipLocationId"
                    customStyles="compDetailsFormLabel"
                    label={Constants.LOCATION_ID_LABEL}
                    toolTipText={"Shipping Location ID (Latitude , Longitude)"}
                  />
                  <Form.Control
                    readOnly={true}
                    style={{ border: "0px", backgroundColor: "#fff" }}
                    id={"latitude"}
                    name={"latitude"}
                    value={`${coordinateDetails.latitude}${coordinateDetails.longitude}`}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group as={Col} md={5}>
                  <ToolTip
                    toolTipId="toolTipLocationName"
                    customStyles="compDetailsFormLabel"
                    label={Constants.LOCATION_NAME_LABEL}
                    mandate={Constants.REQUIRED}
                    toolTipText={"Name of the shipping location."}
                  />
                  <Form.Control
                    required={true}
                    type="text"
                    name={"locationName"}
                    placeholder={"MTECH Atlanta"}
                    value={shippingLocs.locationName}
                    {...register("locationName", {
                      required: "Required",
                      onChange: handleChange,
                    })}
                    disabled={!isLocationActive()}
                  />
                  <span style={{ color: "#d64a4a" }}>
                    {errors?.locationName?.message}
                  </span>
                </Form.Group>

                <Form.Group as={Col} md={3}>
                  <ToolTip
                    toolTipId="toolTipStatus"
                    customStyles="compDetailsFormLabel"
                    label={Constants.STATUS_LABEL}
                  />
                  <Form.Control
                    as="select"
                    required={false}
                    type="select"
                    name={"status"}
                    value={shippingLocs.status}
                    onChange={handleChange}
                  >
                    <option>{Constants.ACTIVE}</option>
                    {(updatedLocation || isUpdateFrm) && (
                      <option>{Constants.INACTIVE}</option>
                    )}
                  </Form.Control>
                </Form.Group>
              </Form.Row>

              <Row></Row>

              <Form.Row>
                <ShippingTitleName title={"Address Details"} />
              </Form.Row>

              {shippingLocationAddressFields().map((address, index) => {
                const addressType = address[0].automationId;
                return (
                  <Form.Row key={addressType} className="col-md-12 mt-2">
                    <SimilarAddresses
                      handleValidate={handleValidate}
                      errors={formValues.errors}
                      address={address}
                      formValues={formValues}
                      disableFields={
                        updatedLocation || updateStatus || isUpdateFrm
                      }
                      fieldValueObject={formValues[addressType]}
                      setFormValues={setFormValues}
                      onAutoCompleteChange={defaultAutoCompleteFieldChange}
                      onSelectAddress={(selectedAddress, props) => {
                        defaultOnSelectAddress(selectedAddress, props);
                      }}
                      setCoordinates={setCoordinates}
                      pageFrom="shippingLocation"
                    />
                  </Form.Row>
                );
              })}

              <Row></Row>

              <Form.Row>
                <ShippingTitleName
                  title={"Contact Details"}
                  locToolTipTxt={
                    "Provide location's operations contact to be notified"
                  }
                />
              </Form.Row>

              <div>
                {shippingLocs.uniqueContactError && (
                  <OnSubmitErrorMessage
                    type="error"
                    message={"You cannot have duplicate contacts."}
                  />
                )}
              </div>
              {shippingLocs.contacts?.map((input, i) => {
                return (
                  <>
                    <Form.Row key={i} className="col-md-12">
                      <Form.Group
                        as={Col}
                        md={2}
                        onSubmit={handleSubmit(onSubmitHandler)}
                      >
                        <ToolTip
                          toolTipId="toolTipFirstName"
                          customStyles="compDetailsFormLabel"
                          label={"First Name"}
                          toolTipText={"First name of contact"}
                          mandate={Constants.REQUIRED}
                        />
                        <Form.Control
                          type="text"
                          id={`contacts.${i}.firstName`}
                          name={`contacts.${i}.firstName`}
                          placeholder="John"
                          value={input.firstName}
                          {...register(`contacts.${i}.firstName`, {
                            required: "Required",
                            name: `contacts.${i}.firstName`,
                            onChange: (e) => handleContactChange(e, i),
                          })}
                          disabled={!isLocationActive()}
                        />
                        {errors.contacts && errors.contacts[i]?.firstName && (
                          <span style={{ color: "#d64a4a" }}>
                            {errors.contacts[i]?.firstName?.message}
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} md={2}>
                        <ToolTip
                          toolTipId="toolTipLastName"
                          customStyles="compDetailsFormLabel"
                          label={"Last Name"}
                          toolTipText={"Last name of contact"}
                          mandate={Constants.REQUIRED}
                        />
                        <Form.Control
                          type="text"
                          id={`contacts.${i}.lastName`}
                          name={`contacts.${i}.lastName`}
                          placeholder="Doe"
                          value={input.lastName}
                          {...register(`contacts.${i}.lastName`, {
                            required: "Required",
                            name: `contacts.${i}.lastName`,
                            onChange: (e) => handleContactChange(e, i),
                          })}
                          disabled={!isLocationActive()}
                        />
                        {errors.contacts && errors.contacts[i]?.lastName && (
                          <span style={{ color: "#d64a4a" }}>
                            {errors.contacts[i]?.lastName?.message}
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} md={3}>
                        <ToolTip
                          toolTipId="toolTipPhoneNumber"
                          customStyles="compDetailsFormLabel"
                          label={"Phone Number"}
                          toolTipText={"Phone Number of contact"}
                          mandate={Constants.REQUIRED}
                        />
                        <Form.Control
                          type="text"
                          id={`contacts.${i}.phoneNumber`}
                          name={`contacts.${i}.phoneNumber`}
                          placeholder={"(423)892-7212"}
                          maxLength="10"
                          value={input.phoneNumber}
                          {...register(`contacts.${i}.phoneNumber`, {
                            required: "Required",
                            name: `contacts.${i}.phoneNumber`,
                            onChange: (e) => handleContactChange(e, i),
                          })}
                          disabled={!isLocationActive()}
                        />
                        {errors.contacts && errors.contacts[i]?.phoneNumber && (
                          <span style={{ color: "#d64a4a" }}>
                            {errors.contacts[i]?.phoneNumber?.message}
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} md={3}>
                        <ToolTip
                          toolTipId="toolTipEmail"
                          customStyles="compDetailsFormLabel"
                          label={"Email"}
                          toolTipText={"Email of contact"}
                          mandate={Constants.REQUIRED}
                        />
                        <Form.Control
                          type="text"
                          id={`contacts.${i}.email`}
                          name={`contacts.${i}.email`}
                          placeholder={"john.doe@macys.com"}
                          value={input.email}
                          {...register(`contacts.${i}.email`, {
                            required: "Required",
                            name: `contacts.${i}.email`,
                            onChange: (e) => handleContactChange(e, i),
                          })}
                          disabled={!isLocationActive()}
                        />
                        {errors.contacts && errors.contacts[i]?.email && (
                          <span style={{ color: "#d64a4a" }}>
                            {errors.contacts[i]?.email?.message}
                          </span>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} md={1}>
                        <ToolTip
                          toolTipId="toolTipPrimary"
                          customStyles="compDetailsFormLabel"
                          label={"Primary"}
                          toolTipText={"Specify one primary contact"}
                        />
                        <Form.Check
                          type="checkbox"
                          id={`contacts.${i}.primary`}
                          name={`contacts.${i}.primary`}
                          checked={
                            shippingLocs.contacts[i].primary ? true : false
                          }
                          onChange={(e) => handlePrimaryChange(e, i)}
                          style={{
                            paddingLeft: "35px",
                            transform: "scale(2)",
                            width: "20px",
                            paddingRight: "-10px",
                            paddingTop: "5px",
                          }}
                          disabled={!isLocationActive()}
                        />
                      </Form.Group>

                      <Form.Group as={Col} md={1} className="p-top-20">
                        {shippingLocs.contacts.length !== 1 && (
                          <Form.Row>
                            <div
                              className="delete"
                              onClick={() =>
                                isLocationActive() && handleRemoveRow(i)
                              }
                            >
                              {Constants.BTN_REMOVE}
                            </div>
                          </Form.Row>
                        )}
                        {shippingLocs.contacts.length - i === 1 && (
                          <Form.Row>
                            <div
                              className="add"
                              onClick={() =>
                                isLocationActive() && handleAddClick()
                              }
                            >
                              {Constants.ADD_MORE}
                            </div>
                          </Form.Row>
                        )}
                      </Form.Group>
                    </Form.Row>
                  </>
                );
              })}

              <Row></Row>

              <Form.Row>
                <ShippingTitleName
                  title={"Day of Week - Operating Hours"}
                  locToolTipTxt={
                    "Select all days at which this location operates"
                  }
                />
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col} md={4}>
                  <ToolTip
                    toolTipId="toolTipTimezone"
                    customStyles="compDetailsFormLabel"
                    label="Timezone"
                    mandate={!Constants.REQUIRED}
                    toolTipText={"Please set your timezone."}
                  />
                  <Form.Control
                    type="text"
                    readOnly={true}
                    id={"timezone"}
                    name={"timezone"}
                    value={`${coordinateDetails.tmstamp}`}
                    onChange={handleChange}
                    disabled={updatedLocation}
                  />
                </Form.Group>

                <Form.Group as={Col} md={4}>
                  <ToolTip
                    toolTipId="toolTipOpenHours"
                    customStyles="compDetailsFormLabel"
                    label="Open 24/7"
                    mandate={Constants.REQUIRED}
                    toolTipText={"Please choose one."}
                  />
                  <Form.Control
                    as="select"
                    required={true}
                    type="select"
                    name={"openHours"}
                    value={shippingLocs.openHours}
                    onChange={handleChange}
                    disabled={!isLocationActive()}
                  >
                    <option>Yes</option>
                    <option>No</option>
                  </Form.Control>
                </Form.Group>
              </Form.Row>

              <Row></Row>

              {shippingLocs.dateArray?.map((input, i) => {
                return (
                  <Form.Row className=".checkbox-container .form-check" key={i}>
                    {(() => {
                      const rows = [];
                      for (const dayKey in Constants.OBJ_WEEK_DAYS) {
                        rows.push(
                          <Form.Group as={Col} md={1}>
                            <ToolTip
                              toolTipId={"toolTip" + dayKey}
                              customStyles="compDetailsFormLabel"
                              label={dayKey}
                            />
                            <Form.Check
                              type="checkbox"
                              name={Constants.OBJ_WEEK_DAYS[dayKey]}
                              onChange={handleDateFlip}
                              defaultChecked={
                                shippingLocs?.dateArray[i][
                                  Constants.OBJ_WEEK_DAYS[dayKey]
                                ]
                              }
                              checked={
                                shippingLocs?.dateArray[i][
                                  Constants.OBJ_WEEK_DAYS[dayKey]
                                ]
                              }
                              disabled={
                                !isLocationActive() ||
                                shippingLocs?.disableAllDays ||
                                false
                              }
                            />
                          </Form.Group>
                        );
                      }
                      return rows;
                    })()}
                  </Form.Row>
                );
              })}

              <Row></Row>

              <Form.Row onSubmit={handleSubmit(onSubmitHandler)}>
                <Col sm={6}>
                  <Button
                    id="shippingCancelBtn"
                    className="button-primary-md"
                    onClick={(event) => handleCancelClick(event)}
                  >
                    {Constants.BUTTON_CANCEL}
                  </Button>
                </Col>

                <Col sm={6}>
                  <Button
                    id="shippingSaveBtn"
                    className="button-primary-md float-right"
                    disabled={
                      !validFlag ||
                      isFilledContacts ||
                      !primaryExist ||
                      !isDataChange ||
                      savePressed
                    }
                    onClick={() => handleSave()}
                  >
                    {Constants.BUTTON_SAVE}
                  </Button>
                </Col>
              </Form.Row>
            </>
          ) : (
            <span></span>
          )}
        </>
      </Form>
    </div>
  );
};

export default LocationDetails;
